import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_SHARE]: 'Share',
  [StringId.DV_DP_SHARE_COPY_LINK]: 'Copy link',
  [StringId.DV_DP_SHARE_COPIED]: 'Copied!'
}